module.exports = __webpack_public_path__ + "img/pricing.6d078550.jpg";